import { SubmittalProps } from "@/interfaces/submittal_types";
import { SubmittalCard } from "../Cards/SubmittalCard";
import { SectionDivRow } from "./Components/SectionDivRow";
import { SectionDiv } from "./Components/SectionDiv";

type SubmittalSectionProps = {
    sorted_submittals: SubmittalProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}


export function SubmittalSection(
    { sorted_submittals, isNewCard, markAsSeen }: SubmittalSectionProps
) {
    return (
        <SectionDiv>
            <h3>My Submittals:</h3>

            <SectionDivRow>
                {sorted_submittals.length > 0 ? sorted_submittals.map((submittal) => (
                    submittal.status === "Closed" ? null :
                        <SubmittalCard
                            key={submittal.submittal_id}
                            submittal={submittal}
                            isNew={isNewCard('submittal', submittal.submittal_id ?? '')}
                            onView={() => markAsSeen('submittal', submittal.submittal_id ?? '')} />
                ))
                    :
                    <h3>No Submittals assigned to you</h3>}
            </SectionDivRow>
        </SectionDiv>
    );
}
